import React, { useEffect, useRef, useState } from "react";
import {
  AVTAR_IMG,
  BELLICON,
  PROFILE_ICON,
  SCORE_ICON,
  SETTING,
  TOGGLELEFTARROW,
  TOGGLERIGHTARROW,
} from "../../../utills/image-constant";
import { useSelector } from "react-redux";
import { ROUTES } from "../../routes/url-constant";
import { Link } from "react-router-dom";
import AdminNotification from "../../pages/page/adminNotification";
import { allNotification, statusChangeNotifiaction } from "../../../services/api-services";

const TopBar = ({ toggleSidebar, isSidebarVisible }) => {
  const { value } = useSelector((state) => state?.loggedUser);
  const adminRole = useSelector((state) => state?.adminRole?.value);

  const [notificationOpen, setNotificationOpen] = useState(false);
  const [notification, setNotification] = useState();
  const [notificationCount, setNotificationCount] = useState();
  const [pandding, setPandding] = useState(false);
  const notificationRef = useRef(null);

  // Helper condition: true if user has multiple or non-assessor roles
  const showNotification =
    Array.isArray(adminRole) &&
    (adminRole.length > 1 ||
      adminRole.some(
        (role) => role?.moduleCode?.toLowerCase() !== "assessor"
      ));

  const handleNotification = () => {
    setNotificationOpen(!notificationOpen);
  };

  const getAllNotify = async () => {
    setPandding(true);
    try {
      const response = await allNotification();
      if (response?.data?.responseCode === 200) {
        setNotification(response?.data?.responseBody);
        setNotificationCount(response?.data?.UnseenStatusCount);
        setPandding(false);
      } else if (response?.data?.responseCode === 404) {
        setNotification();
        setNotificationCount();
      } else {
        setPandding(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const changeAllSeenStauts = async (Id, Status) => {
    try {
      const response = await statusChangeNotifiaction(Id, Status);
      if (response?.data?.responseCode === 200) {
        getAllNotify();
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Call notifications only if user is not only an Assessor
  useEffect(() => {
    if (showNotification) {
      getAllNotify();
    }
  }, [adminRole]);

  // Handle click outside notification box
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setNotificationOpen(false);
      }
    };

    if (notificationOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [notificationOpen]);

  return (
    <>
      <div className="navbar_content">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between p-4 px-2">
            {/* Left Section */}
            <div className="d-flex">
              <div className="togglebtn-sec">
                <img
                  className="togglebtn me-3 d-none d-lg-flex"
                  src={isSidebarVisible ? TOGGLELEFTARROW : TOGGLERIGHTARROW}
                  alt="togglebtn"
                  width="35px"
                  onClick={toggleSidebar}
                />
              </div>
              <div className="header_left_section">
                <p className="mb-0 hellotext">Hello {value?.name}!</p>
                <p className="mb-2 mb-lg-0 textfont12">
                  Welcome to caspera. Hope you are doing well!
                </p>
              </div>
            </div>

            {/* Right Section */}
            <div className="d-flex justify-content-lg-end justify-content-start">
              <div
                className={`header_right_section ${isSidebarVisible ? "otherclassNameActive" : ""
                  }`}
              >
                <div className="d-flex pe-5 ps-md-5 ps-lg-0">
                  {/* Notification Icon — only visible if allowed */}
                  {showNotification && (
                    <div className="cursor-pointer" onClick={handleNotification}>
                      <div className="notify-count d-flex justify-content-center">
                        <p className="mt-1">
                          {notificationCount ? notificationCount : "0"}
                        </p>
                      </div>
                      <img
                        className="headericon notification_contentc"
                        src={BELLICON}
                        alt="Notification Icon"
                      />
                    </div>
                  )}

                  {/* Settings Dropdown */}
                  <div className="ps-3">
                    <div className="dropdown profile-dropdown-container me-3 cursor-pointer">
                      <img
                        className="headericon dropdown-toggle"
                        src={SETTING}
                        id="dropdownMenu2"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      />
                      <div
                        className="dropdown-menu mt-3 p-2 rounded-4 border-0 shadow-lg profile-dropdown"
                        aria-labelledby="dropdownMenu2"
                      >
                        <Link
                          to={ROUTES.ADMINPROFILE}
                          className="text-decoration-none"
                        >
                          <div>
                            <img src={PROFILE_ICON} alt="Profile" />
                            <span className="ms-2">My Profile</span>
                          </div>
                        </Link>
                        <hr className="mt-2 mb-2" />
                        <Link
                          to={ROUTES.ADMINCHANGEPASSWORD}
                          className="text-decoration-none"
                        >
                          <div>
                            <img src={SCORE_ICON} alt="Change Password" />
                            <span className="ms-2">Change Password</span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Profile Section */}
          <div className="bg-white shadow-sm profile_content">
            <div className="profile_image frameimg">
              <img
                src={value?.imageUrl ? value?.imageUrl : AVTAR_IMG}
                className="img-fluid"
                alt="Profile Avatar"
              />
            </div>
            <div className="d-flex flex-wrap text-dark pt-2 align-items-center">
              <p className="mb-2 ps-4 px-3 austintext">{value?.name}</p>
              <p className="mb-2 ps-3 admintext">
                {value?.roleResponsePayload?.roleName}
              </p>
            </div>
          </div>
        </div>

        {/* Notification Dropdown Component — only render if allowed */}
        {showNotification && notificationOpen && (
          <AdminNotification
            notificationOpen={notificationOpen}
            setNotificationOpen={setNotificationOpen}
            notification={notification}
            pandding={pandding}
            changeAllSeenStauts={changeAllSeenStauts}
            ref={notificationRef}
          />
        )}
      </div>
    </>
  );
};

export default TopBar;
